import { render, staticRenderFns } from "./ProductReportsScoreChart.vue?vue&type=template&id=5d166351&scoped=true"
import script from "./ProductReportsScoreChart.vue?vue&type=script&lang=js"
export * from "./ProductReportsScoreChart.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsScoreChart.vue?vue&type=style&index=0&id=5d166351&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d166351",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d166351')) {
      api.createRecord('5d166351', component.options)
    } else {
      api.reload('5d166351', component.options)
    }
    module.hot.accept("./ProductReportsScoreChart.vue?vue&type=template&id=5d166351&scoped=true", function () {
      api.rerender('5d166351', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/ProductReportsScoreChart.vue"
export default component.exports